import { Pipe, PipeTransform } from '@angular/core';
import { CustomerContextService } from 'src/app/core-module/services/customer-context.service';

@Pipe({
  name: 'customerTerm',
  standalone: true,
  pure: false
})
export class CustomerTermPipe implements PipeTransform {
  constructor(private customerContext: CustomerContextService) { }

  transform(termKey: string, plural = false): string {
    return this.customerContext.term(termKey, plural);
  }
}

@Pipe({
  name: 'customerText',
  standalone: true,
  pure: false
})
export class CustomerTextPipe implements PipeTransform {
  constructor(private customerContext: CustomerContextService) { }

  transform(value: string | null | undefined): string {
    return this.customerContext.displayText(value);
  }
}

